import {createContext, useState, useContext} from 'react';

export const SidebarContext = createContext(undefined);

export const SidebarContextAPI = ({children}) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    window.addEventListener('resize', () => {
        if (window.innerWidth < 1366) {
            setIsSidebarOpen(false);
        }
    });

    return (
        <SidebarContext.Provider value={{isSidebarOpen, toggleSidebar, isCollapsed, toggleCollapse}}>
        {children}
        </SidebarContext.Provider>
    );
}

export const useSidebarContext = () => useContext(SidebarContext);

